module.exports = __webpack_public_path__ + "static/media/advantage-3.4fa87055.svg";